import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicDerivations = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Derivations, Parse Trees, and Ambiguity in CFG"
      videos={[
        "https://www.youtube.com/embed/0dS3Wi9F7No",
        "https://www.youtube.com/embed/gUaAKAj-rqA",
        "https://www.youtube.com/embed/i-xrAmOR314",
        "https://www.youtube.com/embed/_rcDHRk1_zo",
      ]}
      takeaways={[
        { text: "Direct questions from this topic are common, usually asking to prove that a given grammar is ambiguous." },
        { text: "Focus on constructing derivation trees and checking if multiple parse trees exist for the same input string." },
      ]}
      questions={[]}
      exampleVideos={[]}
    />
  );
}

export { ModuleSubtopicDerivations };
